import React from "react";

/**
 * Small "Made by TELL CELL" attribution card. Used on public pages
 * (login, register, settings about) so visitors can trace the developer.
 *
 * Renders a subtle white pill with the tellcelltr.com logo + a small line
 * of Turkish attribution text. Opens tellcelltr.com in a new tab.
 */
export default function MadeByBadge({ className = "", variant = "light" }) {
  const bg = variant === "dark" ? "bg-[#0A0A0A] text-white" : "bg-white text-[#0A0A0A]";
  // The upstream tellcelltr.com logo is white text on a transparent background
  // (designed for dark headers). On our light pill we need to invert it so it
  // renders as black text; on our dark variant we leave it as-is.
  const logoFilter = variant === "dark" ? undefined : "invert(1)";
  return (
    <a
      href="https://tellcelltr.com"
      target="_blank"
      rel="noopener noreferrer"
      data-testid="made-by-tellcell"
      className={`inline-flex items-center gap-2 border-hard-2 shadow-hard-sm rounded-full pl-3 pr-3.5 py-1.5 press-btn ${bg} ${className}`}
    >
      <span className="text-[9px] uppercase font-black tracking-widest opacity-70">Yapımcı</span>
      <img
        src="/tellcell-logo.png"
        alt="TELL CELL"
        className="h-5 w-auto object-contain"
        loading="lazy"
        style={logoFilter ? { filter: logoFilter } : undefined}
      />
    </a>
  );
}
